import { Logging } from '../../../utils/logging';

export class lineItemListColumnInfo {
  public columnName: string;
  public userReadableName: string;
  public visible: boolean;
  public canBeRemoved: boolean;
  public filterable: boolean;
  public columnHeaderName: string;
  public includeWithExport: boolean;
}

export class lineItemListColumnData {
  public batchProcessDate: lineItemListColumnInfo;
  public batchUploadDate: lineItemListColumnInfo;
  public errorDesc: lineItemListColumnInfo;
  public fileName: lineItemListColumnInfo;
  public lineItemListID: lineItemListColumnInfo;
  public noOfRecords: lineItemListColumnInfo;
  public statusDesc: lineItemListColumnInfo;
  public userID: lineItemListColumnInfo;
  public downloadButton: lineItemListColumnInfo;
}

export class LineItemListDisplayableColumns {
  public columns: lineItemListColumnData;

  public constructor() {
    this.columns = new lineItemListColumnData();
    //#region Column data
    this.columns.batchProcessDate = {
      canBeRemoved: true,
      visible: true,
      columnName: 'batchProcessDate',
      userReadableName: 'Process Date',
      columnHeaderName: 'Process Date',
      filterable: true,
      includeWithExport: true,
    };
    this.columns.batchUploadDate = {
      canBeRemoved: true,
      columnName: 'batchUploadDate',
      userReadableName: 'Upload Date',
      columnHeaderName: 'Upload Date',
      visible: true,
      filterable: true,
      includeWithExport: true,
    };
    this.columns.errorDesc = {
      canBeRemoved: true,
      columnName: 'errorDesc',
      userReadableName: 'Error',
      columnHeaderName: 'Download Error File',
      visible: false,
      filterable: true,
      includeWithExport: true,
    };
    this.columns.fileName = {
      canBeRemoved: true,
      visible: true,
      columnName: 'fileName',
      userReadableName: 'File Name',
      columnHeaderName: 'File Name',
      filterable: true,
      includeWithExport: true,
    };
    this.columns.lineItemListID = {
      canBeRemoved: false,
      columnName: 'lineItemListID',
      userReadableName: 'Line-Item List ID',
      columnHeaderName: 'Line-Item List ID',
      visible: true,
      filterable: true,
      includeWithExport: true,
    };
    this.columns.noOfRecords = {
      canBeRemoved: true,
      columnName: 'noOfRecords',
      userReadableName: 'Record Count',
      columnHeaderName: 'Record Count',
      visible: true,
      filterable: true,
      includeWithExport: true,
    };
    this.columns.statusDesc = {
      canBeRemoved: true,
      visible: false,
      columnName: 'statusDesc',
      userReadableName: 'Status',
      columnHeaderName: 'Status',
      filterable: true,
      includeWithExport: true,
    };
    this.columns.userID = {
      canBeRemoved: true,
      columnName: 'userID',
      userReadableName: 'User',
      columnHeaderName: 'User',
      visible: true,
      filterable: true,
      includeWithExport: true,
    };
    this.columns.downloadButton = {
      canBeRemoved: false,
      columnName: 'downloadButton',
      columnHeaderName: 'Download Results File',
      visible: true,
      filterable: false,
      includeWithExport: false,
      userReadableName: 'Download File',
    };
    //#endregion
  }

  public orderColumnKeys = [
    'lineItemListID',
    'fileName',
    'batchUploadDate',
    'batchProcessDate',
    'noOfRecords',
    'statusDesc',
    'userID',
    'downloadButton',
    'errorDesc',
  ];

  public columnsAsArray(): lineItemListColumnInfo[] {
    const result = [];
    try {
      this.orderColumnKeys.forEach(key => {
        let child = this.columns[key];
        if (!child.out) result.push(child);
      });
    } catch (e) {
      Logging.error('Error is ColumnsAsArray');
    }
    return result;
  }

  public loadDisplayableColumns() {
    try {
      let s = JSON.parse(localStorage.getItem('HiddenColumnsLineItemListPage'));
      this.columns.batchProcessDate.visible = s.batchProcessDate.visible;
      this.columns.batchUploadDate.visible = s.batchUploadDate.visible;
      this.columns.errorDesc.visible = s.errorDesc.visible;
      this.columns.fileName.visible = s.fileName.visible;
      this.columns.lineItemListID.visible = s.lineItemListID.visible;
      this.columns.noOfRecords.visible = s.noOfRecords.visible;
      this.columns.statusDesc.visible = s.statusDesc.visible;
      this.columns.userID.visible = s.userID.visible;
    } catch (Exception) {
      this.columns.batchProcessDate.visible = true;
      this.columns.batchUploadDate.visible = true;
      this.columns.errorDesc.visible = true;
      this.columns.fileName.visible = true;
      this.columns.lineItemListID.visible = true;
      this.columns.noOfRecords.visible = true;
      this.columns.statusDesc.visible = true;
      this.columns.userID.visible = true;
    }
  }

  public columnDisplayArray(): string[] {
    const result = [];
    let cols = this.columnsAsArray();
    cols.forEach(c => {
      if (c.visible) result.push(c.columnName);
    });
    return result;
  }
}
